import { render, staticRenderFns } from "./ChooseDaPei.vue?vue&type=template&id=979d940a&scoped=true&"
import script from "./ChooseDaPei.vue?vue&type=script&lang=js&"
export * from "./ChooseDaPei.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDaPei.vue?vue&type=style&index=0&id=979d940a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d940a",
  null
  
)

export default component.exports